import { FormStatus } from '@/common/index'

const Roles = [
  {
    code: 'Initiator',
    name: 'Initiator'
  },
  {
    code: 'Coinitiator',
    name: 'Co-Initiator'
  },
  {
    code: 'Facilitator',
    name: 'Facilitator'
  },
  {
    code: 'FacilitatorBackup',
    name: 'Back up Facilitator'
  },
  {
    code: 'Owner',
    name: 'Owner'
  },
  {
    code: 'Coordinator',
    name: 'Coordinator'
  },
  {
    code: 'CommunityOwner',
    name: 'Community Owner'
  },
  {
    code: 'ProcessManager',
    name: 'Process Manager'
  },
  {
    code: 'ProcessManagerBackup',
    name: 'Process Manager Backup'
  },
  {
    code: 'Approvers',
    name: 'Approver'
  },
  {
    code: 'Fyis',
    name: 'FYI'
  },
  {
    code: 'line-manager',
    name: 'Line Manager'
  },
  {
    code: 'vp',
    name: 'Senior Management'
  }
]

const NOTIFICATION_STATUS = [
  {
    ...FormStatus.properties[FormStatus.DRAFT],
    templates: [
      {
        content: '<div>MOC URL: {{url}}</div><div><br></div><div>MOC Title: {{title}}</div>',
        subject: 'Draft saved - {{mocId}} - {{title}}',
        emailType: 'initials'
      },
      {
        content: '<div>MOC URL: {{url}}</div><div><br></div><div>MOC Title: {{title}}</div>',
        subject: 'REMINDER: Draft saved - {{mocId}} - {{title}}',
        emailType: 'reminders'
      }
    ]
  },
  {
    ...FormStatus.properties[FormStatus.SUBMITTED],
    extraProps: [
      {
        currentPassLabel: {
          label: 'Current Pass Label'
        }
      }
    ],
    templates: [
      {
        content:
          '<div><strong style="color: rgb(230, 0, 0);">Please process this MOC now.</strong></div><div><br></div><div>MOC URL: {{url}}</div><div><br></div><div>MOC Title: {{title}}</div><div><br></div><div>Change Category: {{changeCategory}}</div>',
        subject: 'Submitted - Please process - {{mocId}} - {{title}}',
        emailType: 'initials'
      },
      {
        content:
          '<div><strong style="color: rgb(230, 0, 0);">Please process this MOC now.</strong></div><div><br></div><div>MOC URL: {{url}}</div><div><br></div><div>MOC Title: {{title}}</div><div><br></div><div>Change Category: {{changeCategory}}</div>',
        subject: 'REMINDER: Submitted - Please process - {{mocId}} - {{title}}',
        emailType: 'reminders'
      },
      {
        content: '<div><div>MOC URL: {{url}}</div></div>',
        subject: 'Facilitator has not processed a submitted MOC in the amount of days allowed according to community rules',
        emailType: 'reminders'
      }
    ]
  },
  {
    ...FormStatus.properties[FormStatus.SENTBACKFORCORRECTIONS],
    templates: [
      {
        content:
          '<div>Facilitator comments: {{sentBackReason;reason}}</div><div><br></div><div>MOC URL: {{url}}</div><div><br></div><div>MOC Title: {{title}}</div><div><br></div><div>Please contact {{sentBackReason;sentBackBy}} with any questions.</div>',
        subject: 'Address Facilitator comments - {{mocId}} - {{title}}',
        emailType: 'initials'
      },
      {
        content:
          '<div>Facilitator comments: {{sentBackReason;reason}}</div><div><br></div><div>MOC URL: {{url}}</div><div><br></div><div>MOC Title: {{title}}</div><div><br></div><div>Please contact {{sentBackReason;sentBackBy}} with any questions.</div>',
        subject: 'REMINDER: Address Facilitator comments - {{mocId}} - {{title}}',
        emailType: 'reminders'
      }
    ]
  },
  {
    ...FormStatus.properties[FormStatus.AVAILABLEFORDECISION],
    extraProps: [
      {
        currentPassLabel: {
          label: 'Current Pass Label'
        }
      }
    ],
    templates: [
      {
        content:
          '<div> MOC Title:&nbsp;{{title}}</div><div><br></div><div> MOC URL: {{url}}</div><div><br></div><div> Please make your decision by: {{approveBy}}</div>',
        subject: 'Approve or Reject this proposed change - {{mocId}} - {{title}}',
        emailType: 'initials'
      },
      {
        content:
          '<div>MOC Title: {{title}}</div><div><br></div><div>MOC URL: {{url}}</div><div><br></div><div>You will not be able to vote but you can add comments to the Discussion&nbsp;or contact the Owner or Initiator with any concerns that you may have.</div><div><br></div><div>MOC Owner: {{owner}}</div><div><br></div><div>MOC Initiator: {{initiator}}</div>',
        subject: 'Review potential impact to your area - {{mocId}} - {{title}}',
        emailType: 'initials'
      },
      {
        content:
          '<div>MOC Title:&nbsp;{{title}}</div><div><br></div><div>MOC URL: {{url}}</div><div><br></div><div>{{owner}}, if the change proposal needs to be revised or voided, you may take action now.&nbsp;You may also review the list of approvers and FYIs and modify if necessary.</div><div><br></div><div>Approvers:</div><div>{{#approvers}}{{/approvers}}</div><div><br></div><div>FYI:</div><div>{{#fyis}}{{/fyis}}</div>',
        subject: 'Approvers are now deciding on this proposed change - {{mocId}} - {{title}}',
        emailType: 'initials'
      },
      {
        content:
          '<div>MOC Title:&nbsp;{{title}}</div><div><br></div><div> MOC URL: {{url}}</div><div><br></div><div> Please make your decision by: {{approveBy}}</div>',
        subject: 'REMINDER: Approve or Reject this proposed change - {{mocId}} - {{title}}',
        emailType: 'reminders'
      },
      {
        content:
          '<div>MOC Title: {{title}}</div><div><br></div><div>MOC URL: {{url}}</div><div><br></div><div>You will not be able to vote but you can add comments to the Discussion&nbsp;or contact the Owner or Initiator with any concerns that you may have.</div><div><br></div><div>MOC Owner: {{owner}}</div><div><br></div><div>MOC Initiator: {{initiator}}</div>',
        subject: 'REMINDER: Review potential impact to your area - {{mocId}} - {{title}}',
        emailType: 'reminders'
      },
      {
        content:
          '<div>MOC Title: {{title}}</div><div><br></div><div>MOC URL: {{url}}</div><div><br></div><div>{{owner}}, if the change proposal needs to be revised or voided, you may take action now.&nbsp;You may also review the list of approvers and FYIs and modify if necessary.</div><div><br></div><div>Approvers:</div><div>{{#approvers}}{{/approvers}}</div><div><br></div><div>FYI:</div><div>{{#fyis}}{{/fyis}}</div>',
        subject: 'REMINDER: Approvers are now deciding on this proposed change - {{mocId}} - {{title}}',
        emailType: 'reminders'
      }
    ]
  },
  {
    ...FormStatus.properties[FormStatus.PENDINGOWNERDECISION],
    extraProps: [
      {
        currentPassLabel: {
          label: 'Current Pass Label'
        }
      }
    ],
    templates: [
      {
        content:
          '<div>You will be notified of the outcome.</div><div><br></div><div>{{url}}</div><div><br></div><div>MOC Title: {{title}}</div>',
        subject: 'With the owner for final decision - {{mocId}} - {{title}}',
        emailType: 'initials'
      },
      {
        content:
          '<div>{{url}}</div><div><br></div><div>MOC Title: {{title}}</div><div><br></div><div>Approvals: {{approvedCount}}</div><div><br></div><div>Rejections: {{rejectedCount}}</div><div><br></div><div>Here are the people who have not voted on this MOC:\n{{#approversMissingDecision}}{{/approversMissingDecision}}</div>',
        subject: 'Owner decision is needed from you - {{mocId}} - {{title}}',
        emailType: 'initials'
      },
      {
        content:
          '<div>You will be notified of the outcome.</div><div><br></div><div>{{url}}</div><div><br></div><div>MOC Title: {{title}}</div>',
        subject: 'REMINDER: With the owner for final decision - {{mocId}} - {{title}}',
        emailType: 'reminders'
      },
      {
        content:
          '<div>{{url}}</div><div><br></div><div>MOC Title: {{title}}</div><div><br></div><div>Approvals: {{approvedCount}}</div><div><br></div><div>Rejections: {{rejectedCount}}</div><div><br></div><div>Here are the people who have not voted on this MOC:\n{{#approversMissingDecision}}{{/approversMissingDecision}}</div>',
        subject: 'REMINDER: Owner decision is needed from you - {{mocId}} - {{title}}',
        emailType: 'reminders'
      }
    ]
  },
  {
    ...FormStatus.properties[FormStatus.BEINGREVISED],
    templates: [
      {
        content: '<div>MOC URL: {{url}}</div><div><br></div><div>MOC Title: {{title}}</div>',
        subject: '{{status}} - {{mocId}} - {{title}}',
        emailType: 'initials'
      },
      {
        content: '<div>MOC URL: {{url}}</div><div><br></div><div>MOC Title: {{title}}</div>',
        subject: 'REMINDER:  {{status}} - {{mocId}} - {{title}}',
        emailType: 'reminders'
      }
    ]
  },
  {
    ...FormStatus.properties[FormStatus.AVAILABLETOIMPLEMENT],
    templates: [
      {
        content: '<div>MOC URL: {{url}}</div><div><br></div><div>MOC Title: {{title}}</div>',
        subject: 'Begin Implementation of this approved change - {{mocId}} - {{title}}',
        emailType: 'initials'
      },
      {
        content: '<div>MOC URL: {{url}}</div><div><br></div><div>MOC Title: {{title}}</div>',
        subject: 'Approved and now {{coordinator}} will facilitate implementation of the change',
        emailType: 'initials'
      },
      {
        content: '<div>MOC URL: {{url}}</div><div><br></div><div>MOC Title: {{title}}</div>',
        subject: 'REMINDER: Begin Implementation of this approved change - {{mocId}} - {{title}}',
        emailType: 'reminders'
      },
      {
        content: '<div>MOC URL: {{url}}</div><div><br></div><div>MOC Title: {{title}}</div>',
        subject: 'REMINDER: Approved and now {{coordinator}} will facilitate implementation of the change',
        emailType: 'reminders'
      }
    ]
  },
  {
    ...FormStatus.properties[FormStatus.CHANGEISINPLACEWITHCONSEQUENTIALACTIONSREQUIRED],
    templates: [
      {
        content:
          '<div>MOC URL: {{url}}</div><div><br></div><div>MOC Title: {{title}}</div><div><br></div><div>{{closerDeniedReason;reason}}</div>',
        subject: 'Change is in place with consequential actions required',
        emailType: 'initials'
      },
      {
        content:
          '<div>MOC URL: {{url}}</div><div><br></div><div>MOC Title: {{title}}</div><div><br></div><div>{{closerDeniedReason;reason}}</div>',
        subject: 'REMINDER:  Please review consequential actions and complete them satisfactorily.',
        emailType: 'reminders'
      }
    ]
  },
  {
    ...FormStatus.properties[FormStatus.CHANGEISFULLYIMPLEMENTED],
    templates: [
      {
        content: '<div>MOC URL: {{url}}</div><div><br></div><div>MOC Title: {{title}}</div>',
        subject: 'Please close',
        emailType: 'initials'
      },
      {
        content: '<div>MOC URL: {{url}}</div><div><br></div><div>MOC Title: {{title}}</div>',
        subject: 'REMINDER:  Please close',
        emailType: 'reminders'
      }
    ]
  },
  {
    ...FormStatus.properties[FormStatus.CLOSEDVOIDED],
    hideReminders: true,
    templates: [
      {
        subject: 'Closed Voided - {{mocId}} - {{title}}',
        content: '<div>No further action will occur. Reason: {{closedVoidReason;reason}}, {{url}}, MOC Title: {{title}}</div>',
        emailType: 'initials'
      }
    ]
  },
  {
    ...FormStatus.properties[FormStatus.CLOSEDREJECTED],
    hideReminders: true,
    templates: [
      {
        subject: 'Rejected by the Owner and is closed - {{mocId}} - {{title}}',
        content:
          '<div>MOC URL: {{url}}</div><div><br></div><div>MOC Title: {{title}}</div><div><br></div><div>Reason: {{ownerDecisionReason}}</div>',
        emailType: 'initials'
      }
    ]
  },
  {
    ...FormStatus.properties[FormStatus.CLOSEDSTRANDED],
    hideReminders: true,
    templates: [
      {
        subject: 'Closed Stranded - {{mocId}} - {{title}}',
        content:
          '<div>No further action will occur. Reason: {{closedStrandedReason;justification}}, {{url}}, MOC Title: {{title}}</div>',
        emailType: 'initials'
      }
    ]
  }
]

const NOTIFICATION_TAGS = [
  {
    key: 'newapproversaddedbyowner',
    value: 'New Approvers/FYIs Added',
    hideReminders: true,
    enabled:true,
    extraProps: [
      {
        currentPassLabel: {
          label: 'Current Pass Label'
        }
      }
    ],
    templates: [
      {
        content: '<div> MOC Title:&nbsp;{{title}}</div><div><br></div><div> MOC URL: {{url}}</div><div></div>',
        subject: 'Approve or Reject this proposed change - {{mocId}} - {{title}}',
        emailType: 'initials'
      }
    ]
  },
  {
    key: 'remindnonresponderspendingownerdecision',
    value: 'Approvers who have not responded yet in pending owner decision status',
    hideReminders: true,
    enabled:true,
    extraProps: [
      {
        currentPassLabel: {
          label: 'Current Pass Label'
        }
      }
    ],
    templates: [
      {
        content: '<div> MOC Title:&nbsp;{{title}}</div><div><br></div><div> MOC URL: {{url}}</div><div></div>',
        subject: 'Approve or Reject this proposed change - {{mocId}} - {{title}}',
        emailType: 'initials'
      }
    ]
  },
  {
    key: 'remindnonrespondersavailablefordecision',
    value: 'Approvers who have not responded yet in available for decision status',
    hideReminders: true,
    enabled:true,
    extraProps: [
      {
        currentPassLabel: {
          label: 'Current Pass Label'
        }
      }
    ],
    templates: [
      {
        content: '<div> MOC Title:&nbsp;{{title}}</div><div><br></div><div> MOC URL: {{url}}</div><div></div>',
        subject: 'Approve or Reject this proposed change - {{mocId}} - {{title}}',
        emailType: 'initials'
      }
    ]
  },
  {
    key: 'temporaryownerextendnodecision',
    value: 'Temporary Extend',
    hideReminders: true,
    enabled:true,
    extraProps: [
      {
        currentPassLabel: {
          label: 'Current Pass Label'
        }
      }
    ],
    templates: [
      {
        content: '<div> MOC Title:&nbsp;{{title}}</div><div><br></div><div> MOC URL: {{url}}</div><div></div>',
        subject: 'Temporary MOC Extended - {{mocId}} - {{title}}',
        emailType: 'initials'
      }
    ]
  },
   {
    key: 'temporaryreturntooriginalcondition',
    value: 'Temporary Return to Original Condition',
    hideReminders: true,
    enabled:true,
    extraProps: [
      {
        currentPassLabel: {
          label: 'Current Pass Label'
        }
      }
    ],
    templates: [
      {
        content: '<div> MOC Title:&nbsp;{{title}}</div><div><br></div><div> MOC URL: {{url}}</div><div></div>',
        subject: 'Temporary MOC Return to Original Condition - {{mocId}} - {{title}}',
        emailType: 'initials'
      }
    ]
  },
  {
    key: 'temporaryunauthorizedexpired',
    value: 'Temporary Unauthorized Expired',
    enabled:true,
    templates: [
      {
        content: '<div> MOC Title:&nbsp;{{title}}</div><div><br></div><div> MOC URL: {{url}}</div><div></div>',
        subject: 'Temporary Unauthorized Expired - {{mocId}} - {{title}}',
        emailType: 'initials'
      },
      {
        content: '<div>MOC URL: {{url}}</div><div><br></div><div>MOC Title: {{title}}</div>',
        subject: 'REMINDER:  Temporary Unauthorized Expired',
        emailType: 'reminders'
      }
    ]
  },
  {
    key: 'temporaryabouttoexpire',
    value: 'Temporary About To Expire',
    customFrequency: true,
    enabled:true,
    templates: [
      {
        content: '<div> MOC Title:&nbsp;{{title}}</div><div><br></div><div> MOC URL: {{url}}</div><div></div>',
        subject: 'Temporary About To Expire - {{mocId}} - {{title}}',
        emailType: 'initials'
      },
      {
        content: '<div>MOC URL: {{url}}</div><div><br></div><div>MOC Title: {{title}}</div>',
        subject: 'REMINDER:  Temporary About To Expire',
        emailType: 'reminders'
      }
    ]
  },
  {
    key: 'makepermextendavailablefordecision',
    value: 'Make Permanent or Extend in Available For Decision Notice',
    hideInitials: true,
    enabled:true,
    extraProps: [
      {
        currentPassLabel: {
          label: 'Current Pass Label'
        },
        rejectors: {
          label: 'People who have rejected',
          isArray: true
        }
      }
    ],
    templates: [
      {
        content: '<div> MOC Title:&nbsp;{{title}}</div><div><br></div><div> MOC URL: {{url}}</div><div></div>',
        subject: '{{status}} - {{mocId}} - {{title}}',
        emailType: 'reminders'
      }
    ]
  },
  {
    key: 'taskassignment',
    value: 'Task Assignment',
    enabled:true,
    extraRoles: [
      {
        code: 'task-assignee',
        name: 'Task assignee'
      }
    ],
    extraProps: [
      {
        tasks: {
          label: 'Tasks',
          isArray: true
        }
      }
    ],
    templates: [
      {
        content: '<div> MOC Title:&nbsp;{{title}}</div><div><br></div><div> MOC URL: {{url}}</div><div></div>',
        subject: 'Task Assignment - {{mocId}} - {{title}}',
        emailType: 'initials'
      },
      {
        content: '<div>MOC URL: {{url}}</div><div><br></div><div>MOC Title: {{title}}</div>',
        subject: 'REMINDER: Task Assignment',
        emailType: 'reminders'
      }
    ]
  },
  {
    key: 'longopen',
    value: 'Long Open (Owner approved start date + MOC Duration in Days)',    
    enabled:false,
    templates: [
      {
        content: '<div> MOC Title:&nbsp;{{title}}</div><div><br></div><div> MOC URL: {{url}}</div><div></div>',
        subject: '{{status}} - {{mocId}} - {{title}}',
        emailType: 'initials'
      },
      {
        content: '<div> MOC Title:&nbsp;{{title}}</div><div><br></div><div> MOC URL: {{url}}</div><div></div>',
        subject: '{{status}} - {{mocId}} - {{title}}',
        emailType: 'reminders'
      }
    ]
  }
]

const emailBodyAndSubjectByStatusDefault = {
  initials: {
    content: '<div>MOC URL: {{url}}</div><div><br></div><div>MOC Title: {{title}}</div>',
    subject: '{{status}} - {{mocId}} - {{title}}'
  },
  reminders: {
    content: '<div>MOC URL: {{url}}</div><div><br></div><div>MOC Title: {{title}}</div>',
    subject: 'REMINDER: {{status}} - {{mocId}} - {{title}}'
  }
}

export { NOTIFICATION_STATUS, emailBodyAndSubjectByStatusDefault, NOTIFICATION_TAGS, Roles }
